import { render } from "./CentroDistribuicao.vue?vue&type=template&id=76d2b20d&scoped=true"
import script from "./CentroDistribuicao.vue?vue&type=script&lang=js"
export * from "./CentroDistribuicao.vue?vue&type=script&lang=js"

import "./CentroDistribuicao.vue?vue&type=style&index=0&id=76d2b20d&scoped=true&lang=css"

import exportComponent from "E:\\amapa-lp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76d2b20d"]])

export default __exports__